export enum InvestigationReturnNoteLocation {
	AttributedFacts = 1,
	Discussion = 2,
	Findings = 3,
	Recommendation = 4,
}
